import _slicedToArray from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React, { useState } from "react";
import { bool, array, func, object, string } from "prop-types";
import Styled from "styled-components"; // Colors

import { extended, primary } from "@uprise/colors"; // Spacing

import { spacing } from "@uprise/spacing"; // Components

import { H4 } from "@uprise/headings";
import { Medium } from "@uprise/text"; // Icons

import Icons from "@uprise/icons";
var AccordianItemStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding-top: ", ";\n      border-bottom: 1px solid ", ";\n\n      &:first-child {\n            padding-top: 0;\n      }\n"])), spacing.s6, extended.purple.four);
var ContentWrap = Styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      max-height: ", ";\n      overflow: hidden;\n      transition: padding 0.3s, opacity 0.3s linear;\n      opacity: ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n"])), function (props) {
  return props.toggle ? "100%" : "0";
}, function (props) {
  return props.toggle ? 1 : 0;
}, function (props) {
  return props.toggle ? spacing.s6 : "0px";
}, function (props) {
  return props.toggle ? spacing.s6 : "0px";
});
var HeaderWrap = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      display: flex;\n      flexDirection: row;\n      justify-content: space-between;\n      cursor: pointer;\n      padding-bottom: ", ";\n"])), function (props) {
  return props.toggle ? 0 : spacing.s6;
});
var ToggleIcon = Styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      height: 9px;\n      width: 16px;\n      margin-top: ", ";\n      margin-right: ", ";\n      transform: ", ";\n      transition: transform 0.1s linear;\n"])), spacing.s5, spacing.s7, function (props) {
  return props.toggle ? "rotate(180deg)" : "none";
});
export var AccordianItem = function AccordianItem(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var _useState = useState(children[0]),
      _useState2 = _slicedToArray(_useState, 2),
      header = _useState2[0],
      setHeader = _useState2[1];

  var _useState3 = useState(children[1]),
      _useState4 = _slicedToArray(_useState3, 2),
      content = _useState4[0],
      setContent = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      toggle = _useState6[0],
      setToggle = _useState6[1];

  var _handleClick = function _handleClick() {
    setToggle(!toggle);
  };

  return /*#__PURE__*/React.createElement(AccordianItemStyle, {
    className: className
  }, /*#__PURE__*/React.createElement(HeaderWrap, {
    toggle: toggle,
    onClick: function onClick() {
      return _handleClick();
    }
  }, /*#__PURE__*/React.createElement(H4, null, header), /*#__PURE__*/React.createElement(ToggleIcon, {
    toggle: toggle,
    src: Icons.chevronPurple
  })), /*#__PURE__*/React.createElement(ContentWrap, {
    toggle: toggle
  }, content));
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

AccordianItem.propTypes = {
  className: string,
  children: array
};
AccordianItem.defaultProps = {};